import useSWR from 'swr';
import StoreWebservice from "../../webservices/StoreWebservice"

const storeWebservice = new StoreWebservice();

const useSessionToken = (id: string, sessionToken: string) => {
  return useSWR(
    () => {
      if (!id) {
        throw new Error();
      }

      return `/v1/stores/${id}/check_session`;
    },
    async () => {
      return storeWebservice.checkSessionToken(id, sessionToken)
    }
  )
}

export default useSessionToken;
